var map = {
	"./background-desktop-bottom.svg": "1995",
	"./background-desktop-top.svg": "f51f",
	"./background-desktop-white.svg": "a44f",
	"./background-mobile-bottom.svg": "ce35",
	"./background-mobile-top.svg": "8b08",
	"./banner1.png": "2633",
	"./bg-flow.svg": "6969",
	"./btn-bg-black-sloped.svg": "4a77",
	"./btn-bg-black.svg": "3a67",
	"./btn-bg-white-sloped.svg": "0a3d",
	"./btn-bg-white.svg": "84c5",
	"./btn-border-black-sloped.svg": "fd47",
	"./btn-border-black.svg": "3baf",
	"./deco-black-bg-white-line.svg": "6b79",
	"./deco-border-left-top.svg": "85bb",
	"./deco-border-right-bottom.svg": "854c",
	"./deco-title.svg": "11b5",
	"./icon-borrow-btc-usdt.svg": "c0d3",
	"./icon-borrow-ebt-usdt.svg": "92f4",
	"./icon-borrow-egt-tbt.png": "74b7",
	"./icon-borrow-egt-usdt.svg": "9b26",
	"./icon-borrow-eos-usdt.svg": "1887",
	"./icon-borrow-eth-usdt.svg": "4619",
	"./icon-borrow-eth.png": "bcdd",
	"./icon-borrow.svg": "929a",
	"./icon-bscegt-tbt.png": "da4b",
	"./icon-bscegt-usdt.png": "1b3d",
	"./icon-btc.svg": "38df",
	"./icon-buy.png": "75bd",
	"./icon-calculator.svg": "f511",
	"./icon-community.svg": "7859",
	"./icon-deposit.svg": "5082",
	"./icon-ebt.svg": "bdad",
	"./icon-egt-tbt.png": "a206",
	"./icon-egt-usdt.png": "9fbc",
	"./icon-egt.svg": "6eae",
	"./icon-eos.svg": "9ec0",
	"./icon-eth.svg": "6918",
	"./icon-game-tbt.png": "7b96",
	"./icon-game-usdt.png": "a985",
	"./icon-index-usdt.svg": "7a6d",
	"./icon-registry.svg": "294a",
	"./icon-sell.png": "03e5",
	"./icon-tbt-text.png": "aeb1",
	"./icon-translate.svg": "3f01",
	"./icon-twd-black.svg": "04f8",
	"./icon-twd.svg": "7b76",
	"./icon-usdt-black.svg": "0395",
	"./icon-usdt-text.png": "971a",
	"./icon-usdt.svg": "27dc",
	"./logo.png": "4ffd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";